import { Box, Dialog, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { ICON, LOGO } from "../../../assets";
import confs from "../../../configurations";
import { navigate } from "../../../routes";
import { admin } from "../../../routes/admin";
import { main } from "../../../routes/main";
import { useAuth } from "../../Auth/useAuth";
import { useCart } from "../../Carts/useCart";
import useTranslations from "../../Translations/useTranslations";
import UiBadge, { UI_BADGE_TYPE } from "../../ui/UiBadge";
import UiIcon from "../../ui/UiIcon";
import { welcomeLogo as logo } from "../../logo";
import "./ApplicationHeader.css";

function ApplicationHeader({
  leftSideContent,
  rightSideContent,
  navLinks,
  headerConfig = {
    showBrand: true,
    showDefaultRoutes: true,
    showUserMenu: true,
    showcart: false,
    addLinksInDefault: false,
  },
}) {
  const showBrand = headerConfig.showBrand || true;
  const showDefaultRoutes = headerConfig.showDefaultRoutes || true;
  const showUserMenu = headerConfig.showUserMenu || true;
  const showcart = headerConfig.showcart || false;
  const addLinksInDefault = headerConfig.addLinksInDefault || false;
  const [auth, authMethods] = useAuth();
  const [carts, setCarts] = useCart(auth.user.client_profile?.id);
  const trl = useTranslations();
  const [profileOpen, isProfileOpen] = useState(false);
  const [logoutClientFirst, islogoutClientFirst] = useState(false);

  const clientOfOperator = auth?.user?.client_profile;

  function renderViewCart() {
    const cartCount = carts?.carts?.length;
    return (
      <React.Fragment>
        <Nav.Link
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            navigate.push(admin.VIEW_CART);
          }}
        >
          <div className="view-cart on-hover">
            <span>{cartCount === 0 ? "Mes panier" : "Mes paniers"}</span>
            {cartCount > 0 && (
              <UiBadge
                content={cartCount}
                badgeUiType={[UI_BADGE_TYPE.SMALL]}
              />
            )}
          </div>
        </Nav.Link>
      </React.Fragment>
    );
  }

  function renderDefaultRoutes() {
    if (showDefaultRoutes) {
      const { URL_API, URL_GED } = confs;
      const CODGRT = auth.user?.client_profile?.codgrt || auth.user.codgrt;
      const navLinkStyle = { color: "#171717", fontSize: "15px" };
      let defaultLinks = [];
      if (authMethods.isRoleClient() || clientOfOperator) {
        defaultLinks = [
          {
            label: "Mes commandes & factures",
            href: admin.ORDER_AND_INVOICE.path,
          },
          {
            label: trl.message("MainPage.Link.priceLabel"),
            href: `${URL_GED}/Edoc/${CODGRT}/tarif${CODGRT}.pdf`,
            openNewTab: true,
          },
          {
            label: trl.message("MainPage.Link.imageBankLabel"),
            href: "https://drive.google.com/drive/folders/1lztKfla-WKEGC1BRQDFZ68S-ZxFYcDyS?usp=sharing",
            openNewTab: true,
          },
          {
            label: trl.message("MainPage.Link.brandToolsLabel"),
            href: "https://drive.google.com/drive/folders/1gskGY0EP8HDdVJxrJU9O3S0giYymoDwl?usp=sharing",
            openNewTab: true,
          },
        ];
      } else {
        defaultLinks = [
          {
            label: "Mes clients",
            href: admin.USER_LIST.path,
          },
          {
            label: "Outils de vente",
            href: "https://drive.google.com/drive/folders/1gskGY0EP8HDdVJxrJU9O3S0giYymoDwl",
            openNewTab: true,
          },
          {
            label: "Drive France",
            href: " https://drive.google.com/drive/folders/1lztKfla-WKEGC1BRQDFZ68S-ZxFYcDyS",
            openNewTab: true,
          },
        ];
      }
      const navLinkDatas = addLinksInDefault
        ? [...navLinks, ...defaultLinks]
        : navLinks || defaultLinks;
      return (
        <React.Fragment>
          <Nav.Link
            className="d-flex align-items-center"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              navigate.push(main.HOME);
            }}
          >
            <UiIcon alt="home_icon" icon={ICON.homeIcon} size="md" />
          </Nav.Link>
          {showcart && renderViewCart()}
          {navLinkDatas.map((navLinkData, i) => {
            return (
              <Nav.Link
                style={navLinkStyle}
                href={navLinkData.href}
                key={i}
                target={navLinkData.openNewTab ? "_blank" : ""}
                rel="noreferrer"
                className="on-hover"
              >
                {navLinkData.label}
              </Nav.Link>
            );
          })}
        </React.Fragment>
      );
    }
  }

  function renderBrandLogo() {
    if (!showBrand) return null;
    return (
      <React.Fragment>
        <Navbar.Brand
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            navigate.push(main.HOME);
          }}
        >
          <img
            alt=""
            src={logo}
            width="130"
            height="40"
            className="d-inline-block align-top"
            style={{ cursor: "pointer" }}
          />
        </Navbar.Brand>
      </React.Fragment>
    );
  }

  function renderUserProfile() {
    if (!auth.user.data) return null;
    const user =
      authMethods.isRoleOperator() && clientOfOperator
        ? clientOfOperator
        : auth.user.data;
    return (
      <React.Fragment>
        <Nav.Link
          className="d-flex align-items-center"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            isProfileOpen(true);
          }}
        >
          <UiIcon alt="profile_icon" icon={ICON.profileIcon} size="md" />
          {auth.user && auth.user.nomcli}
        </Nav.Link>
        {/*  profile info container  */}
        <Dialog open={profileOpen} onClose={() => isProfileOpen(false)}>
          <Box p={3}>
            <Typography color="primary" component="p" variant="body1">
              {trl.message("HomePage.Dialog.contactNameLabel")}
            </Typography>
            <Typography component="p" variant="body2">
              {user.name}: <a href={`mailto:${user.email}`}>{user.email}</a>,{" "}
              <a href={`tel:${user.tel}`}>{user.tel}</a>
            </Typography>
          </Box>
        </Dialog>
      </React.Fragment>
    );
  }

  function renderUserMenu() {
    if (!showUserMenu) return null;
    return (
      <React.Fragment>
        <Nav.Item
          className="d-flex align-items-center "
          style={{ gap: "1rem" }}
        >
          {renderUserProfile()}
          <Nav.Link
            className="d-flex align-items-center"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              clientOfOperator?.id && authMethods.isRoleOperator()
                ? islogoutClientFirst(true)
                : authMethods.logout();
            }}
          >
            <UiIcon alt="power_icon" icon={ICON.powerIcon} size="md" />
          </Nav.Link>
        </Nav.Item>
        <Dialog
          open={logoutClientFirst}
          onClose={() => islogoutClientFirst(false)}
        >
          <Box p={3}>
            <Typography
              color="primary"
              component="p"
              variant="body1"
              className="user-menu__action"
            >
              <UiIcon
                className="user-menu__close-icon"
                icon={ICON.closeCrossIcon}
                onClick={() => islogoutClientFirst(false)}
                size="md"
              />
              <span className="user-menu__close-text">
                Pour vous déconnecter, veuillez quitter la vue client.
              </span>
            </Typography>
          </Box>
        </Dialog>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Container fluid className="header-container">
        <Navbar
          expand={showcart ? "lg" : "md"}
          className="justify-content-between"
        >
          {renderBrandLogo()}
          <Nav.Item>{leftSideContent}</Nav.Item>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-end "
          >
            <Nav className="align-center" style={{ gap: "1rem" }}>
              {rightSideContent}
              {renderDefaultRoutes()}
              {renderUserMenu()}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </React.Fragment>
  );
}

export default ApplicationHeader;
